/*
 * @Descripttion:
 * @version:
 * @Author: jing
 * @Date: 2020-09-15 10:23:04
 * @LastEditors: jing
 * @LastEditTime: 2020-12-10 21:35:14
 */
let baseUrl = `http://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-make/vcard3/`;
export const videoList = {
  gfsf: [
    {
      videosrc: `${baseUrl}qw.mp4`,
      main_img: `${baseUrl}cover-qw2.jpeg`,
      title: "区位",
      times: 1234,
      id: 1,
      showTitle: false
    },
    {
      videosrc: `${baseUrl}st.mp4`,
      main_img: `${baseUrl}cover-st2.jpeg`,
      title: "生态",
      times: 1234,
      id: 2,
      showTitle: false
    },
    {
      videosrc: `${baseUrl}wy.mp4`,
      main_img: `${baseUrl}cover-wy2.jpeg`,
      title: "物业",
      times: 1234,
      id: 3,
      showTitle: false
    }
  ],
  twsf: [
    {
      videosrc: `${baseUrl}video_zhyshjg.mp4`,
      main_img: `${baseUrl}cover-jg.jpeg`,
      title: "景观",
      times: 1234,
      id: 4,
      showTitle: false
    },
    {
      videosrc: `${baseUrl}125%E5%AE%A4%E5%86%85.mp4`,
      main_img: `${baseUrl}cover-hx.jpeg`,
      title: "户型",
      times: 123,
      id: 5,
      showTitle: false
    },
    // {
    //   videosrc: `${baseUrl}125%E6%88%B7%E5%9E%8B%E5%B1%95%E7%A4%BA.mp4`,
    //   main_img: `${baseUrl}poster_125hx.png`,
    //   title: "户型",
    //   times: 1234,
    //   id: 5
    // },
    {
      videosrc: `${baseUrl}ybj.mp4`,
      main_img: `${baseUrl}cover-ybj.jpeg`,
      title: "样板间",
      times: 123,
      id: 6,
      showTitle: false
    }
  ]
};
